(function ($) {
  Drupal.behaviors.beWhoYouAreV1 = {
    attach: function (context) {
      var self = this;
      var tile = 'bwya__tile';
      var tileContainer = tile + '--container';
      var tileImage = tile + '--image';

      $(document).on('bwya::loadedYoutubeIframeAPI', function (e) {
        self.vidSetup(e);
      });

      // Change mobile override in overlay.js.
      $(document).on('overlay::mobileOverride', function (e, cboxArgs) {
        _.extend(cboxArgs, {
          height: '400px',
          width: '100%'
        });
      });

      // Create tile container.
      $('.' + tile + ':first', context).wrap('<div class="' + tileContainer + '"></div>');
      // Collect and append B.W.Y.A tiles into container.
      var $tiles = $('.' + tile, context).detach();

      $('.' + tileContainer, context).append($tiles);

      // Keep consistent tile heights.
      function _tidyTiles() {
        $('.' + tileImage).matchHeight();

        return;
      }
      $(window).on('resize-debounced', _tidyTiles);
      _tidyTiles();
      $(document).ready(function () {
        // Cleaner looking tile load.
        $('.bwya__page--loading-overlay').fadeIn(600);
        $('.bwya__page').removeClass('bwya__page--loading-overlay');
      });
    },

    createVideoPlayerDiv: function ($elem, i) {
      var id = $elem.attr('class') + '-' + i;

      $elem
        .append('<div />')
        .children('div')
        .attr('id', id);

      return id;
    },
    addVideo: function (ytId, iframeId) {
      var player = new YT.Player(iframeId, {
        height: '100%',
        width: '100%',
        videoId: ytId,
        playerVars: {
          // controls: 0
        },
        events: {
          onReady: function (event) {
            // Don't autoplay on mobile
            if (!Modernizr.touch) {
              // event.target.playVideo();
            }
          },
          onStateChange: function (event) {
            // stuff
          },
          onApiChange: function (event) {
          }
        }
      });
    },

    vidSetup: function (event) {
      // Video Setup.
      var self = this;

      $('.bwya__video-tile').each(function (i) {
        var $me = $(this),
          $content = $('.bwya__tile--video', $me),
          $vids = $content.filter(function (i) {
            return $(this).data('video-provider') == 'youtube' && $(this).data('youtube-id').length > 0;
          }),
          $player = $('.bwya__page--video');

        $vids.each(function () {
          var $wrap = $(this),
            ytId = $wrap.data('youtube-id');

          $wrap.click(function (e) {
            // Do something useless
            e.preventDefault();

            // Reset the current player wrapper
            $player.removeClass('active').empty();

            // Create a new div for the player to take over
            var iframeId = self.createVideoPlayerDiv($player, Math.floor(+new Date() / 1000));

            // Add the 'active' class to the player for spacing
            $player.addClass('active');

            // Instantiate the video
            self.addVideo(ytId, iframeId);

            var videoCover = $('.bwya__tile--vid-cover', $me).data('video-cover');

            if (videoCover == undefined) {
              videoCover = 'none';
            }

            // Player we will send to generic.overlay.
            $player.wrapInner("<div class='overlay-video-bwya bwya__page--video bwya--vid-cover' data-video-cover='" + videoCover + "'> </div>");

            var vidHeight = 500;
            var vidWidth = $('.bwya__header--video').innerWidth();

            if (vidHeight != 0 && vidWidth != 0) {
              generic.overlay.launch({
                content: $('.overlay-video-bwya'),
                width: vidWidth,
                height: vidHeight,
                cssClass: 'bwya__colorbox'
              });
            }
            var imgCover = $('.bwya--vid-cover').data('video-cover');

            // Add Video Cover Image if there is one.
            if (imgCover != 'none') {
              var $video = $('.overlay-video-bwya');

              $video.children().hide();
              $video.css('background-image', "url('" + imgCover + "')");
              $video.once().click(function (e) {
                var $vid = $('#' + iframeId);

                if ($vid.length) {
                  // Play video when cover photo clicked.
                  $('#' + iframeId)[0].src += '&autoplay=1';
                }
                $('.overlay-video-bwya').children().show();
              });
            }

            // Do something else that's useless
            return false;
          });
        });
      });

      $('.bwya__header__image').once().click(function (e) {
        $('.bwya__header__image').hide();
      });
    }
  };
  $(document).bind('youtubeIframeAPI.loaded', function (e) {
    // Trigger at end of stack.
    $(document).ready(function () {
      $(document).trigger('bwya::loadedYoutubeIframeAPI', e);
    });
  });
})(jQuery);
